<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <runner-workout-view [clientProgramWorkoutDayId]="clientProgramWorkoutDayId" [clientUserId]="clientUserId" (saved)="workoutSaved()" [isCoachView]="true"></runner-workout-view>
</div>

